export default class Note {
  id;
  uuid;

  name;
  description;
}
